import processingClient from '@/services/clients/processing';

export default {
  namespaced: true,
  state: () => ({
    countryCode: null,
    userGroup: null,
  }),
  getters: {
    isUkUser: state => ['UK', 'GB'].includes(state.countryCode),
    isCAUser: state => state.countryCode === 'CA',
    isPrivateClient: ({ userGroup }) => userGroup === 'client',
  },
  mutations: {
    setCountryCode(state, countryCode) {
      state.countryCode = countryCode;
    },
    setUserInfo(state, { country, userGroup }) {
      state.countryCode = country;
      state.userGroup = userGroup;
    },
  },
  actions: {
    async loadUser({ commit }) {
      const response = await processingClient.getUser();
      commit('setUserInfo', response);
    },
  },
};
